import BusStopData from '../../schema/viewSchema/BusStopData';
import ServiceReservation from '../../schema/ServiceReservation';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 * Extracts the service reservation specific data needed for displaying the bus stop
 */
export default function populateServiceReservationBusStopData(
    entity: ServiceReservation,
    startTime: string,
    ariaStartTime: string,
    txpStrings: TxpStrings,
    icon: string
): BusStopData {
    let ariaBusStopText: string = txpStrings.formatters.format(
        txpStrings.strings.cardSummaryAriaText,
        entity.name,
        ariaStartTime
    );

    return {
        busStopLabel: txpStrings.strings.reservationLabelText,
        busStopText: entity.name,
        collapsedText: startTime,
        ariaBusStopText: ariaBusStopText,
        icon: icon,
    } as BusStopData;
}
